import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="sticky top-0 z-50 bg-white shadow-md border-b-4 border-stone-800">
      <div className="barber-pole h-2 w-full"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 barber-pole rounded-full border-2 border-stone-800 shadow-sm hidden sm:block"></div>
          <div className="flex flex-col">
            <h1 className="text-xl sm:text-2xl font-black tracking-tighter uppercase text-stone-900 font-serif leading-none">
              Norm's Barber Shop
            </h1>
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.3em] text-red-700 mt-1">
              Since 1992
            </span>
          </div>
        </div>
        <nav className="flex items-center">
          <a 
            href="tel:3167218600" 
            className="bg-stone-900 hover:bg-red-800 text-white px-4 py-2 sm:px-6 sm:py-3 text-sm font-bold uppercase tracking-widest transition-all rounded-none shadow-lg flex items-center space-x-3 group"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 group-hover:text-white transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span>(316) 721-8600</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;